import { useRef } from "react"
import { useFrame } from "@react-three/fiber"
import { useGLTF } from "@react-three/drei"
import { EffectComposer, Bloom } from '@react-three/postprocessing'
import { useControls } from "leva"




export default function Box() {
    const { camPosition, color, roughness } = useControls({
        camPosition: {
            value: [100, 0.5, 2]
        },
        color: '#1f3815',
        roughness: 0.05

    })
    const box = useRef()
    const cross = useRef()
    const { nodes } = useGLTF('./appartement/devbox.glb')

    useFrame((state) => {
        box.current.rotation.y += 0.01
        let currency = 0
        currency = Math.abs(Math.sin(state.clock.getElapsedTime() * 0.8)) * 3

        //cross.current.emissiveIntensity = (currency)
    })
    return <>
        <EffectComposer>
            <pointLight position={camPosition} intensity={1} />

            <group dispose={null} ref={box} scale={10}>
                <mesh
                    geometry={nodes.box.geometry}
                    position={[0, 0.05, 0]}
                >
                    <meshStandardMaterial color={color} roughness={roughness} metalness={1} />
                </mesh>
                <mesh
                    geometry={nodes.emissive.geometry}
                    position={[0, 0.05, 0]}
                >
                    <meshStandardMaterial
                        ref={cross}
                        color={[1.2, 1.2, 1.2]}
                        toneMapped={false}
                        emissive="white"
                        emissiveIntensity={3} />
                </mesh>
            </group>
            <Bloom mipmapBlur />
        </EffectComposer>
    </>

    // <mesh ref={box} scale={1.2}>
    //     <boxGeometry attach="geometry" args={[1, 1, 1, 30, 30]} />
    //     <meshBasicMaterial attach="material" color="#e5ab1b" />
    // </mesh>
}